module.exports = __webpack_public_path__ + "static/media/Varus.ea68c045.png";